import {ApiAction} from 'redux-upgrader';

export const GET_COUNTRIES = new ApiAction('GET_COUNTRIES');
export const GET_REGIONS = new ApiAction('GET_REGIONS');
export const GET_COUNTRIES_FOR_FILTER = new ApiAction('GET_COUNTRIES_FOR_FILTER');
export const GET_REGIONS_FOR_FILTER = new ApiAction('GET_REGIONS_FOR_FILTER');
